export function EstoqarMark({ size = 36, className = "", boxColor = "#FFFFFF", boxStroke = "#0F6B3A" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-label="ESTOQAR" data-testid="estoqar-mark">
      <defs>
        <linearGradient id="eq-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2DC26B" />
          <stop offset="1" stopColor="#0F6B3A" />
        </linearGradient>
      </defs>
      <circle cx="30" cy="28" r="22" fill="none" stroke="url(#eq-g)" strokeWidth="8" />
      <path d="M43 42 L58 58" stroke="url(#eq-g)" strokeWidth="9" strokeLinecap="round" />
      <g transform="translate(30 28)">
        <path d="M-9 -4 L0 -9 L9 -4 L9 6 L0 11 L-9 6 Z" fill={boxColor} />
        <path d="M-9 -4 L0 1 L9 -4" fill="none" stroke={boxStroke} strokeWidth="2" />
        <path d="M0 1 L0 11" stroke={boxStroke} strokeWidth="2" />
      </g>
    </svg>
  );
}

export function EstoqarWordmark({ light = true, size = "text-xl" }) {
  return (
    <span className={`font-extrabold tracking-tight ${size} ${light ? "text-white" : "text-[#0F2A1F]"}`} data-testid="estoqar-wordmark">
      ESTO<span className="text-[#2DC26B]">Q</span>AR
    </span>
  );
}
